import styled from 'styled-components'
import { Search, Dropdown } from 'semantic-ui-react'
import Color from 'color'

import Anchor from '@/ui/Anchor'
import Form from '@/ui/Form'

export const FiltersDropdown = styled.div`
  display: flex;
  align-items: baseline;
`

export const DropdownTrigger = styled(Anchor)`
  width: 100%;
  text-align: left;
  cursor: pointer;
`

export const Filters = styled.div<{ isRightColumn?: boolean }>`
  position: absolute;
  left: ${props => (props.isRightColumn ? 'auto' : '0px')};
  right: ${props => (props.isRightColumn ? '0px' : 'auto')};
  top: 100%;
  background: #f9fafb;
  border: 1px solid #e3e4e6;
  border-top: 0;
  min-width: 100%;
  max-height: 15em;
  z-index: 11;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 300px;
`

export const FilterHeader = styled.div`
  margin-bottom: 0.25em;
  padding: 0.1em 0.5em;
  padding-top: 0.3em;
  color: ${props => props.theme.primaryColor};
  font-weight: normal;
  font-size: 0.95em;
`

export const Filter = styled.div`
  cursor: pointer;
  margin-bottom: 0.25em;
  padding: 0.1em 0.5em;
  padding-top: 0.3em;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  :last-child {
    margin-bottom: 0;
  }

  :hover {
    color: #fff;
    background: ${props => props.theme.primaryColor};
  }
`

export const SelectedFilters = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 121px;
`

export const LoaderWrapper = styled.div`
  position: relative;
  height: 50px;
  margin: 1em;
`

export const SearchFallback = styled.div`
  margin: 1em;
  text-align: center;
`

export const FluidSearch = styled(Search)`
  &&& {
    width: 100%;
    padding: 0.5em;

    .input {
      width: 100%;
    }
  }
`

export const FilterMode = styled.div`
  display: flex;
  align-items: center;
  margin: 3px 0;
`
//@ts-ignore
export const SortableForm = styled(Form)`
  padding: 1em;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
`

export const SortDropdown = styled(Dropdown).attrs({
  inline: true,
})`
  &&&&&& {
    padding: 0.25em;
    margin-left: 0.5em;
    min-height: auto !important;
    line-height: initial !important;
    margin-right: 0.5em;
    border: none !important;
    color: ${props => props.theme.colors.textGrey};

    .text {
      font-weight: normal !important;
    }

    .dropdown {
      background: 0;
      border: 0;
      min-height: auto;
      padding: 0;

      &.icon {
        padding: 0 !important;
        top: 0 !important;
      }
    }
  }
`

export const FilterLabel = styled.div<{ negative?: boolean }>`
  display: flex;
  margin-top: 0.25em;

  &&& {
    > * {
      min-width: 0;
      transition: background-color 0.2s ease;
      display: flex;
      height: 30px;
      padding: 0.4em 0.6em;
      background-color: ${props =>
        props.negative ? props.theme.colors.red : props.theme.colors.green};

      :hover {
        background-color: ${props =>
          Color(
            props.negative ? props.theme.colors.red : props.theme.colors.green,
          )
            .darken(0.15)
            .string()};
      }
    }

    > div:first-child {
      border-top-left-radius: 0.25em;
      border-bottom-left-radius: 0.25em;
      cursor: pointer;
      font-weight: bold;
      font-size: 0.9em;

      border-right: 1px solid
        ${props =>
          Color(
            props.negative ? props.theme.colors.red : props.theme.colors.green,
          )
            .darken(0.15)
            .string()};

      span {
        color: #fff;
      }
    }

    .icon-wrapper {
      cursor: pointer;
      flex: 1 0 30px;
      flex-grow: 0;
      border-top-right-radius: 0.25em;
      border-bottom-right-radius: 0.25em;
      margin-left: 0 !important;
      border-left: 1px solid
        ${props =>
          Color(
            props.negative ? props.theme.colors.red : props.theme.colors.green,
          )
            .lighten(0.15)
            .string()};

      :hover {
        background-color: ${props =>
          Color(
            props.negative ? props.theme.colors.red : props.theme.colors.green,
          )
            .darken(0.15)
            .string()};
      }

      .icon {
        padding-top: 2px;
      }
    }
  }
`
